import { apiHolder as api, apis } from 'api';
import React, { useState, useEffect, useRef, useImperativeHandle } from 'react';
import AttachmentCard from '@web-mail/components/AttachmentCard';
import './index.scss';
import classnames from 'classnames';
import { actions as attachmentActions } from '@web-common/state/reducer/attachmentReducer';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
import { useActions, useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import debounce from 'lodash/debounce';
import AttachmentIcon from '../AttachmentIcon';
const eventApi = api.api.getEventApi();
const loggerApi = api.api.requireLogicalApi(apis.loggerApiImpl);
const Attachment = React.forwardRef((props, ref) => {
    const { writeLetterProp } = props;
    const attachmentsDivRef = useRef(null);
    const attachments = useAppSelector(state => state.attachmentReducer.attachments);
    const attachmentsRef = useRef(attachments);
    attachmentsRef.current = attachments;
    const currentMailId = useAppSelector(state => state.mailReducer.currentMail.cid);
    const currentMailIdRef = useRef(currentMailId);
    currentMailIdRef.current = currentMailId;
    const waittingMailIds = useAppSelector(state => state.mailReducer.waittingMailIds);
    const actions = useActions(attachmentActions);
    const [currentLength, setCurrentLength] = useState(0);
    const downloadQueueRef = useRef([]);
    const dispatch = useAppDispatch();
    const cancelUpload = (id) => {
        actions.doDelAttachment({ id });
    };
    const cancelDownload = ({ downloadId, abortDownload, expired }) => {
        if (typeof abortDownload === 'function')
            abortDownload();
        actions.doChangeAttachment({
            downloadId,
            status: 'before',
            expired,
        });
    };
    const debounceSaveDraft = (mailId) => {
        if (!mailId)
            return;
        const currentAttachments = attachmentsRef.current.filter(item => item.mailId === currentMailIdRef.current && item.type !== 'download');
        if (currentAttachments.some(item => (item === null || item === void 0 ? void 0 : item.status) && ['uploading', 'deleting'].includes(item === null || item === void 0 ? void 0 : item.status)))
            return;
        console.log('申请保存草稿');
        eventApi.sendSysEvent({
            eventName: 'toSaveDraft',
            eventStrData: '',
            eventData: {
                type: 'localAndRemote',
                trigger: 'attachChange',
                mailId,
            },
        });
    };
    const checkMailBefSend = (sendMailId) => {
        const mailAtts = (attachmentsRef.current || []).filter(item => item.mailId === sendMailId && item.type !== 'download');
        if (mailAtts.length === 0)
            return false;
        return mailAtts.every(item => item.status === 'success');
    };
    const uploadSucAutoSend = useCreateCallbackForEvent((sendMailId) => {
        if (waittingMailIds.includes(sendMailId)) {
            const checkRes = checkMailBefSend(sendMailId);
            loggerApi.track('upload_suc_auto_send_check', {
                sendMailId,
                checkRes,
                waittingMailIds: waittingMailIds.join(','),
            });
            if (checkRes) {
                eventApi.sendSysEvent({
                    eventName: 'toSendMail',
                    eventStrData: '',
                    eventData: { sendMailId },
                });
            }
        }
    });
    useEffect(() => {
        let list = attachments
            .filter(i => i.mailId === currentMailId)
            .map(v => (Object.assign(Object.assign({}, v), { size: v.size, attachmentType: v.cloudAttachment ? 'netfolder' : v.type })));
        list = list.filter(i => !i.forwardWithout);
        setCurrentLength(list.length);
    }, [attachments, currentMailId]);
    useEffect(() => {
        const eid = eventApi.registerSysEventObserver('attachToCloud', {
            func: e => {
                const { attachItem } = e.eventData;
                const { realId } = attachItem;
                realId && actions.doTransAttachmentToCloud(realId);
            },
        });
        return () => {
            eventApi.unregisterSysEventObserver('attachToCloud', eid);
        };
    }, []);
    useImperativeHandle(ref, () => ({
        scrollIntoView: () => {
            setTimeout(() => {
                attachmentsDivRef.current.scrollIntoView();
            }, 0);
        },
    }));
    const flushDownloadQueue = debounce(() => {
        const sortedArr = downloadQueueRef.current.sort((a, b) => {
            return a.index - b.index;
        });
        downloadQueueRef.current = [];
        while (sortedArr.length) {
            const headOne = sortedArr.shift();
            headOne && (headOne === null || headOne === void 0 ? void 0 : headOne.fun(true));
        }
        actions.doBatchStartAttachments(sortedArr.map(item => item === null || item === void 0 ? void 0 : item.id));
    }, 300);
    const seqDownload = (downloadItem) => {
        downloadQueueRef.current = [...downloadQueueRef.current, downloadItem];
        flushDownloadQueue();
    };
    return (React.createElement("div", { className: "attachment", id: "attachmentArea", ref: attachmentsDivRef },
        React.createElement("div", { className: "attachment-list" },
            attachments.map((file, index) => {
                if (file.type !== 'download') {
                    return (React.createElement(AttachmentCard, { index: index, writeLetterProp: writeLetterProp, optType: "upload", className: classnames('card', { ['hide']: !(file.mailId === currentMailId) }), file: file, key: file.id, id: file.id, noneMoreOperate: true, cancel: () => {
                            cancelUpload(file.id);
                        }, delete: () => {
                            cancelUpload(file.id);
                        }, expired: file.expired, debounceSaveDraft: debounceSaveDraft, seqDownload: seqDownload, uploadSucAutoSend: uploadSucAutoSend }));
                }
                return file.mailId === currentMailId ? (React.createElement(AttachmentCard, { index: index, optType: "download", className: `card ${[file.mailId].includes(currentMailId) && !file.forwardWithout ? '' : 'hide'}`, key: file.fileUrl, downloadInfoStatus: file.status || '', downloadInfoProcess: file.process || 0, noneMoreOperate: true, id: file.downloadId, cancel: () => {
                        cancelDownload(file);
                    }, downloadInfo: file, writeLetterProp: writeLetterProp, expired: file.expired, seqDownload: seqDownload, uploadSucAutoSend: uploadSucAutoSend })) : (React.createElement(React.Fragment, null));
            }),
            Array(20)
                .fill(null)
                .map((_, index) => (React.createElement("div", { key: `f${index}`, className: 'placeholder' })))),
        currentLength ? React.createElement(AttachmentIcon, { currentLength: currentLength }) : ''));
});
export default Attachment;
